// extracted by mini-css-extract-plugin
export var arrow = "_ca-1";
export var content = "_ca-0";
export var highlighted = "_ca-2";